"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var actions_1 = require("./actions");
var initialState = {
    transitioning: false,
    last: {},
};
exports.routerReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case actions_1.START_TRANSITION: {
            return __assign(__assign({}, state), { transitioning: true });
        }
        case actions_1.FINISH_TRANSITION: {
            return {
                transitioning: false,
                last: action.transition,
            };
        }
        case actions_1.IGNORED_TRANSITION: {
            return __assign(__assign({}, state), { transitioning: false });
        }
        default: {
            return state;
        }
    }
};
//# sourceMappingURL=reducer.js.map